import React, { useEffect } from "react";
import Breadcrumb from "../common/Breadcrumb";

function PaymentPageContainer({
  children,
  pricingSection,
  pageName,
  breadcrumb,
  header,
  contentClassname,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="flex w-full min-h-screen relative bg-white flex-col items-center font-main">
      <div className="px-2 w-full max-w-7xl flex flex-col">
        <Breadcrumb currentPage={pageName} breadcrumb={breadcrumb} />
        {header}
        <div
          className={`w-full gap-4 lg:gap-6 flex pb-20 flex-col-reverse lg:flex-row ${contentClassname}`}
        >
          <div className="flex flex-1 flex-col">{children}</div>
          {pricingSection}
        </div>
      </div>
    </div>
  );
}

export default PaymentPageContainer;
